(function () {
  if (window.__lgkNewsletterCtaBound) return;
  window.__lgkNewsletterCtaBound = true;

  function forceVisible(popup) {
    popup.style.setProperty('display', 'block', 'important');
    popup.style.setProperty('z-index', '6000', 'important');
    popup.style.setProperty('opacity', '1', 'important');
    popup.style.setProperty('visibility', 'visible', 'important');
    popup.style.setProperty('pointer-events', 'auto', 'important');
  }

  function tryOpen(popup) {
    if (!popup) return false;

    if (typeof popup.show === 'function') {
      popup.show().catch(function () {
        popup.setAttribute('open', '');
        forceVisible(popup);
      });
      return true;
    }

    popup.setAttribute('open', '');
    forceVisible(popup);
    return true;
  }

  function openNewsletterPopup() {
    var popup = document.querySelector('newsletter-popup');
    if (!popup) return;

    if (tryOpen(popup)) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      popup = document.querySelector('newsletter-popup');
      attempts += 1;
      if (!popup || tryOpen(popup) || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 150);
  }

  window.lgkOpenNewsletterPopup = function (event) {
    if (event) {
      event.preventDefault();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      event.stopPropagation();
    }
    openNewsletterPopup();
  };

  function handleTrigger(event) {
    var trigger = event.target.closest('[data-lgk-open-newsletter]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    openNewsletterPopup();
  }

  document.addEventListener('click', handleTrigger, true);
  document.addEventListener('pointerup', handleTrigger, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var trigger = event.target.closest('[data-lgk-open-newsletter]');
    if (!trigger) return;

    event.preventDefault();
    openNewsletterPopup();
  });
})();
